module.exports = __webpack_public_path__ + "static/media/arrow-back-nfg.903e50bc.svg";